import { Phone, Flame } from "lucide-react";
import { SITE, IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

export default function MinutesChapter() {
  return (
    <Chapter img={IMG.aboutFire} overlay="center" testId="minutes-matter" className="minutes-chapter">
      <div className="absolute top-0 left-0 right-0 h-1 ember-stripe siren-sweep" />
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
        <Reveal y={12}><Flame className="w-12 h-12 text-[hsl(var(--gaza-crimson-bright))] mb-8" strokeWidth={2} /></Reveal>
        <Reveal y={12} delay={0.1}><div className="text-[11px] uppercase tracking-[0.28em] text-[hsl(var(--gaza-crimson-bright))] font-extrabold mb-8">Minutes matter</div></Reveal>
        <LineReveal
          delay={0.2}
          className="display-chunky text-5xl md:text-7xl lg:text-[6.5rem] leading-[0.9] mb-10"
          lines={["The first hour decides", <>what's <span className="text-[hsl(var(--gaza-crimson-bright))]">saved,</span></>, "and what's lost."]}
        />
        <Reveal delay={0.6}>
          <p className="text-xl text-white/80 leading-relaxed max-w-2xl mx-auto">
            Water spreads through floors. Soot bonds to surfaces. Mold begins to set. Don't wait for tomorrow to figure it out. Call now, we'll be on the way before you finish the call.
          </p>
        </Reveal>
        <Reveal delay={0.8}>
          <a href={SITE.phoneHref} className="mt-12 inline-flex items-center gap-4 group text-left" data-testid="minutes-call-btn">
            <span className="w-16 h-16 grid place-items-center bg-[hsl(var(--gaza-crimson-bright))] group-hover:bg-white transition">
              <Phone className="w-6 h-6 text-white group-hover:text-[hsl(var(--gaza-crimson-bright))]" />
            </span>
            <span>
              <div className="text-[11px] uppercase tracking-[0.28em] text-white/70 font-extrabold">Tap to call · 24/7</div>
              <div className="display-chunky text-4xl md:text-5xl text-white group-hover:text-[hsl(var(--gaza-crimson-bright))] transition">{SITE.phone}</div>
            </span>
          </a>
        </Reveal>
      </div>
    </Chapter>
  );
}
